import Breadcrumbs from 'components/breadcrumbs';
import Container from 'components/container';
import SEO from 'components/seo';
import { Tabs } from 'components/tabs';
import React from 'react';

import { aboutUsTabs } from './configs';

const AboutUsPage: React.FC = () => {
  return (
    <>
      <SEO title='Về chúng tôi' />
      <Container className='mb-auto'>
        <Breadcrumbs />
        <div className='w-full'>
          <Tabs tabs={aboutUsTabs} />
        </div>
      </Container>
    </>
  );
};

export default AboutUsPage;
